import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import _ from 'lodash';
import NumberFormat from "react-number-format";
import { useToasts } from "react-toast-notifications";
import { COLOR_APP, COLOR_APP_CANCEL } from "../../../constants";
import { CREATE_ORDER_FROM_POST_COMMENT_HOTFIX } from "../../../graphql/order/mutation";
import { SEND_ORDER_GROUP_BILL } from "../../../graphql/orderGroup/mutation";
import { useMutation } from "@apollo/client";
function CreateOrderModal({ updateLiveStock, updateOrder, fetchPostStocks, getLiveOrders, fetchLiveOrders, liveId, showCreateOrderModal, setShowCreateOrderModal, selectedComment, postStocks, setPostStocks, setLiveComments, liveComments, getOrderData, liveSreenType }) {
    //* ເລືອກໄດ້ຫຼາຍສິນຄ້າ — ແຕ່ລະແຖວ: { postStock, amount }
    //* ຫຼັງບ້ານສ້າງອໍເດີໄດ້ເທື່ອລະໂຕ ຈຶ່ງຍິງເປັນຮອບໆ ແຕ່ທຸກໂຕຈະລວມເຂົ້າບິນດຽວກັນເອງ
    const [selectedRows, setSelectedRows] = useState([]);
    const [stockKeyword, setStockKeyword] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    //* ເກັບ id ອໍເດີໄວ້ ເພື່ອໃຫ້ກົດສົ່ງບິນຄືນໄດ້ ຖ້າສົ່ງບໍ່ອອກ
    //* ອໍເດີສ້າງສຳເລັດໄປແລ້ວ ການສົ່ງບິນຊ້ຳຈຶ່ງບໍ່ສ້າງອໍເດີເພີ່ມ
    const [billOrderId, setBillOrderId] = useState(null);
    const [isSendingBill, setIsSendingBill] = useState(false);
    const [notify, setNotify] = useState({
        show: false,
        msg: "",
        color: ""
    });

    const { addToast } = useToasts();

    // const [createOrder, { loading: createLoading }] = useMutation(CREATE_ORDER_FROM_POST_COMMENT);
    const [createOrder, { loading: createLoading }] = useMutation(CREATE_ORDER_FROM_POST_COMMENT_HOTFIX);
    const [sendOrderGroupBill] = useMutation(SEND_ORDER_GROUP_BILL);

    //* ລາຍການສິນຄ້າໃນໂພສທີ່ຍັງຂາຍໄດ້ + ກັ່ນຕອງຕາມຄຳຄົ້ນຫາ
    const filteredPostStocks = (postStocks ?? []).filter((item) => {
        //* ໂຕທີ່ຕິກໄວ້ແລ້ວໃຫ້ສະແດງສະເໝີ
        //* ບໍ່ດັ່ງນັ້ນພໍພິມຄົ້ນຫາ ມັນຈະຫາຍໄປຈາກໜ້າຈໍ ແຕ່ຍັງຖືກສັ່ງຢູ່ ເຊິ່ງເຮັດໃຫ້ງົງ
        if (selectedRows.some(row => row?.postStock?.id === item?.id)) return true;

        if ((item?.amount ?? 0) <= 0 || !item?.isPublished) return false;

        const _key = (stockKeyword ?? "").trim().toLowerCase();
        if (!_key) return true;

        return (item?.cfMessage ?? "").toLowerCase().includes(_key)
            || (item?.stock?.name ?? "").toLowerCase().includes(_key);
    });

    //* ຕິກ/ຖອນຕິກສິນຄ້າໜຶ່ງໂຕ
    const toggleStockRow = (postStock) => {
        if (!postStock?.id) return;

        setSelectedRows(prev => {
            const _exist = (prev ?? []).some(row => row?.postStock?.id === postStock?.id);
            if (_exist) return prev.filter(row => row?.postStock?.id !== postStock?.id);
            return [...prev, { postStock, amount: 1 }];
        });
    }

    const updateRowAmount = (postStockId, value) => {
        setSelectedRows(prev => prev.map(row => row?.postStock?.id === postStockId ? { ...row, amount: value } : row));
    }

    //* ລວມລາຄາທຸກແຖວ — ຄິດແຍກຕາມສະກຸນເງິນ ບໍ່ດັ່ງນັ້ນກີບກັບບາດຈະຖືກບວກປົນກັນ
    const sumByCurrency = () => {
        const _sum = {};
        selectedRows.forEach((row) => {
            const _currency = row?.postStock?.stock?.currency ?? "ກີບ";
            const _amount = parseInt((row?.amount ?? "").toString().replace(/,/g, "")) || 0;
            const _price = parseFloat(row?.postStock?.stock?.price ?? 0) || 0;
            _sum[_currency] = (_sum[_currency] ?? 0) + (_amount * _price);
        });
        return _sum;
    }

    //* ແປຂໍ້ຜິດພາດຂອງແຕ່ລະແຖວໃຫ້ເປັນຂໍ້ຄວາມທີ່ອ່ານອອກ
    const errorMessage = (error) => {
        const _message = error?.message ?? "";
        if (_message.includes("SHOP_SETTING_NOT_FOUND")) return "ຍັງບໍ່ໄດ້ຕັ້ງຄ່າຮ້ານ";
        if (_message.includes("ORDER_ALREADY_EXISTS")) return "ລູກຄ້າຄົນນີ້ສັ່ງໂຕນີ້ໄປແລ້ວ";
        if (_message.includes("Insufficient post stock")) return "ຈຳນວນໃນໂພສບໍ່ພໍ";
        if (_message.includes("Insufficient stock")) return "ຈຳນວນໃນສາງບໍ່ພໍ";
        return "ຜິດພາດ";
    }

    //* ສົ່ງບິນລວມ 1 ເທື່ອ — คืน true ຖ້າສຳເລັດ
    //*
    //* ໃຊ້ຮ່ວມກັນລະຫວ່າງຕອນສ້າງອໍເດີ ແລະ ປຸ່ມສົ່ງບິນຄືນ
    //* ເອີ້ນຊ້ຳໄດ້ ບໍ່ສ້າງອໍເດີເພີ່ມ ເພາະແຍກອອກຈາກການສ້າງອໍເດີແລ້ວ
    const _sendBill = async (orderId) => {
        if (!orderId) return false;
        try {
            const _bill = await sendOrderGroupBill({
                variables: {
                    where: {
                        order: orderId,
                        pageAccessToken: selectedComment?.pageAccessToken,
                    },
                },
            });
            const _ok = !!_bill?.data?.sendOrderGroupBill?.status;
            if (!_ok) console.log("send bill failed:", _bill?.data?.sendOrderGroupBill?.msg);
            return _ok;
        } catch (error) {
            console.log("sendOrderGroupBill error:", error);
            return false;
        }
    }

    const _resendBill = async () => {
        if (isSendingBill) return;
        setIsSendingBill(true);
        const _ok = await _sendBill(billOrderId);
        setIsSendingBill(false);

        if (_ok) {
            setBillOrderId(null);
            setNotify({ show: true, msg: "ສົ່ງບິນຫາລູກຄ້າສຳເລັດ!", color: "green" });
            return;
        }
        setNotify({
            show: true,
            msg: "ຍັງສົ່ງບິນບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ ຫຼື ແຈ້ງລູກຄ້າເອງ",
            color: "danger"
        });
    }

    //* ສ້າງອໍເດີໃຫ້ທຸກສິນຄ້າທີ່ເລືອກ
    //*
    //* ຫຼັງບ້ານຮັບໄດ້ເທື່ອລະໂຕ ຈຶ່ງຍິງເປັນຮອບ ແລະ ຫຸ້ມ try ເປັນລາຍໂຕ
    //* ໂຕໃດຫຼົ້ມ ໂຕທີ່ສຳເລັດແລ້ວຕ້ອງບໍ່ຖືກຍົກເລີກໄປນຳ
    const _createOrder = async () => {
        try {
            if (createLoading || isSaving) return;

            if (selectedRows.length === 0) {
                setNotify({
                    show: true,
                    msg: "ເລືອກສິນຄ້າໃດຫນຶ່ງກ່ອນ!",
                    color: "orange"
                })
                return;
            }

            //* ກວດຈຳນວນທຸກແຖວກ່ອນ ຈຶ່ງຄ່ອຍເລີ່ມສ້າງ
            const _rows = [];
            for (const row of selectedRows) {
                const _amount = parseInt((row?.amount ?? "").toString().replace(/,/g, "")) || 0;
                if (_amount <= 0) {
                    setNotify({
                        show: true,
                        msg: (row?.postStock?.cfMessage ?? "") + ": ຈໍານວນສິນຄ້າຕ້ອງຫລາຍກວ່າ 1",
                        color: "orange"
                    })
                    return;
                }
                if (_amount > (row?.postStock?.amount ?? 0)) {
                    setNotify({
                        show: true,
                        msg: (row?.postStock?.cfMessage ?? "") + ": ເຫຼືອພຽງ " + (row?.postStock?.amount ?? 0),
                        color: "orange"
                    })
                    return;
                }
                _rows.push({ postStock: row?.postStock, amount: _amount });
            }

            setIsSaving(true);
            const SHOP_ID = await localStorage.getItem("SHOP");

            const _success = [];
            const _failed = [];

            for (const row of _rows) {
                const _stock = row?.postStock;
                try {
                    let _newOrder = {
                        type: liveSreenType ? liveSreenType : "POST",
                        post: liveId,
                        live: liveId,
                        postStock: _stock?.id,
                        liveStock: _stock?.id,
                        stock: _stock?.stock?.id,
                        amount: row?.amount,
                        productName: _stock?.stock?.name ?? "",
                        currency: _stock?.stock?.currency ?? "ກີບ",
                        cfMessage: _stock?.cfMessage ?? "",
                        fbMessage: selectedComment?.message,
                        commentId: selectedComment?.commentId,
                        price: parseInt(_stock?.stock?.price) ?? 0,
                        originPrice: parseInt(_stock?.stock?.originPrice) ?? 0,
                        totalPrice: parseInt(_stock?.stock?.price * row?.amount) ?? 0,
                        cfName: selectedComment?.name,
                        shop: SHOP_ID,
                        userFbId: selectedComment?.psid,
                        pageAccessToken: selectedComment?.pageAccessToken,
                        page: selectedComment?.pageId,
                        //* ບໍ່ໃຫ້ສົ່ງຂໍ້ຄວາມເປັນລາຍສິນຄ້າ — ຈະສົ່ງບິນລວມເທື່ອດຽວຕອນທ້າຍ
                        //*
                        //* Meta ໃຫ້ຕອບ private ຕໍ່ 1 ຄອມເມັນພຽງເທື່ອດຽວ ໂຕທີ 2 ຂຶ້ນໄປຈຶ່ງລົ້ມ
                        //* ແລ້ວຕົກໄປເສັ້ນທາງ fallback ທີ່ຍິງຫຼາຍຮອບ ຊ້າ ແລະ ສ່ຽງຖືກບລັອກເພຈ
                        skipNotify: true
                    }
                    let _res = await createOrder({
                        variables: {
                            data: _newOrder,
                        },
                    });

                    const _orderId = _res?.data?.createOrderFromPostCommentHotfix?.id;
                    if (!_.isEmpty(_orderId)) {
                        _success.push({ ...row, orderId: _orderId });
                    } else {
                        _failed.push((_stock?.cfMessage ?? "") + ": ສ້າງບໍ່ສຳເລັດ");
                    }
                } catch (error) {
                    console.log("_createOrder Error: ", _stock?.cfMessage, error);
                    _failed.push((_stock?.cfMessage ?? "") + ": " + errorMessage(error));
                }
            }

            //* ສົ່ງບິນລວມເທື່ອດຽວ ຫຼັງສ້າງອໍເດີຄົບແລ້ວ
            //*
            //* ຜູກກັບບິນ ບໍ່ແມ່ນຜູກກັບອໍເດີໂຕໃດໂຕໜຶ່ງ ໂຕສຸດທ້າຍລົ້ມກໍຍັງສົ່ງບິນອອກ
            //* ແລະ ບິນຈະສະທ້ອນສະເພາະສິນຄ້າທີ່ສ້າງສຳເລັດຈິງ
            let _billFailed = false;
            if (_success.length > 0) {
                const _lastOrderId = _success[_success.length - 1]?.orderId;
                _billFailed = !(await _sendBill(_lastOrderId));
                //* ເກັບໄວ້ສະເພາະຕອນສົ່ງບໍ່ອອກ ຈະໄດ້ຂຶ້ນປຸ່ມສົ່ງຄືນໃຫ້
                setBillOrderId(_billFailed ? _lastOrderId : null);
            }

            setIsSaving(false);

            if (_success.length > 0) {
                getOrderData({
                    variables: {
                        where: {
                            post: liveId,
                            isDeleted: false
                        },
                        skip: 0,
                        limit: 1000
                    }
                });

                // update post stocks
                const _updatePostStocks = postStocks.map((_postStock) => {
                    const _hit = _success.find(row => row?.postStock?.id === _postStock?.id);
                    if (_hit) return { ..._postStock, amount: parseInt(_postStock?.amount) - _hit?.amount }

                    return _postStock
                })
                setPostStocks(_updatePostStocks);

                // update post comments
                const _updatePostComments = liveComments?.map((_comment) => {
                    if (_comment?.id === selectedComment?.id) return { ..._comment, isCreated: true }

                    return _comment
                })
                setLiveComments(_updatePostComments)
            }

            //* ສົ່ງບິນບໍ່ອອກ ບໍ່ໄດ້ແປວ່າອໍເດີບໍ່ສຳເລັດ — ຕ້ອງບອກຮ້ານໃຫ້ຮູ້ ບໍ່ແມ່ນປິດງຽບ
            const _billNote = _billFailed
                ? " ແຕ່ສົ່ງບິນຫາລູກຄ້າບໍ່ສຳເລັດ ກົດ 'ສົ່ງບິນອີກຄັ້ງ' ດ້ານລຸ່ມ"
                : "";

            //* ຫຼົ້ມໝົດ ຫຼື ຫຼົ້ມບາງໂຕ — ເປີດ modal ໄວ້ ແລະ ເຫຼືອໄວ້ແຕ່ໂຕທີ່ຍັງບໍ່ຜ່ານ
            if (_failed.length > 0) {
                setSelectedRows(prev => prev.filter(row => !_success.some(done => done?.postStock?.id === row?.postStock?.id)));
                setNotify({
                    show: true,
                    msg: (_success.length > 0 ? "ສຳເລັດ " + _success.length + " ລາຍການ. " : "") + "ບໍ່ສຳເລັດ: " + _failed.join(", ") + _billNote,
                    color: _success.length > 0 ? "orange" : "danger"
                })
                return;
            }

            setShowCreateOrderModal(false);
            _clearData();
            setNotify({
                show: true,
                msg: "ສ້າງອໍເດີ້ " + _success.length + " ລາຍການສໍາເລັດ!" + _billNote,
                color: _billFailed ? "orange" : "green"
            })
            return;
        } catch (error) {
            console.log("_createOrder Error: ", error);
            setIsSaving(false);
            setNotify({
                show: true,
                msg: "ເກີດຂໍ້ຜີດພາດທີ່ບໍ່ຄາດຄີດ!",
                color: "danger"
            })
            return;
        }
    }

    const _clearData = () => {
        setSelectedRows([])
        setStockKeyword("")
    }

    return (
        <>
            {/* ບໍ່ໃສ່ scrollable — CSS bootstrap 4 ຈະເຮັດໃຫ້ modal-content ຢືດເຕັມຄວາມສູງ
              * ຈໍ ຈົນເກີດພື້ນທີ່ຫວ່າງໃຫຍ່ຢູ່ລຸ່ມປຸ່ມ ລາຍການສິນຄ້າມີ scroll ຂອງໂຕເອງແລ້ວ
              */}
            <Modal show={showCreateOrderModal} onHide={() => {
                if (createLoading || isSaving) return;
                _clearData();
                setShowCreateOrderModal(false)
            }}>
                <Modal.Body>
                    <h3 style={{ fontWeight: 'bold', alignSelf: 'center' }}>ສ້າງອໍເດີ້</h3>
                    <Form.Group>
                        <div>ຊື່ລູກຄ້າ</div>
                        <Form.Control value={selectedComment?.name} />
                    </Form.Group>
                    <div style={{ margin: '10px 4px' }}>
                        <div style={{ textAlign: "start", marginBottom: 6 }}>ເລືອກສິນຄ້າ (ຕິກໄດ້ຫຼາຍໂຕ)</div>
                        <Form.Control
                            type="text"
                            placeholder="ຄົ້ນຫາຊື່ສິນຄ້າ ຫຼື ລະຫັດ CF..."
                            value={stockKeyword}
                            onChange={(e) => setStockKeyword(e.target.value)}
                        />
                        <div style={{ maxHeight: 300, overflowY: 'auto', marginTop: 8, border: '1px solid #eee', borderRadius: 6 }}>
                            {filteredPostStocks.length === 0 && (
                                <div style={{ padding: 12, color: '#888' }}>ບໍ່ພົບສິນຄ້າທີ່ຍັງຂາຍໄດ້</div>
                            )}
                            {filteredPostStocks.map((item, index) => {
                                const _row = selectedRows.find(row => row?.postStock?.id === item?.id);
                                const _isChecked = !_.isEmpty(_row);
                                return (
                                    <div
                                        key={index}
                                        onClick={() => toggleStockRow(item)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            padding: 8,
                                            cursor: 'pointer',
                                            background: _isChecked ? '#f1efff' : '#fff',
                                            borderBottom: '1px solid #f4f4f4'
                                        }}
                                    >
                                        {/* ໃຊ້ input ທຳມະດາ ບໍ່ໃຊ້ Form.Check
                                          *
                                          * ໂປຣເຈັກນີ້ໂຫຼດ CSS ຂອງ bootstrap 4 ແຕ່ react-bootstrap ເປັນລຸ້ນ 2
                                          * ເມື່ອບໍ່ໄດ້ໃສ່ label ມັນຈະບໍ່ຫຸ້ມດ້ວຍ div .form-check ທີ່ເປັນ
                                          * position:relative ຊ່ອງຕິກທີ່ເປັນ position:absolute ຈຶ່ງຫຼຸດອອກໄປນອກ modal
                                          */}
                                        <input
                                            type="checkbox"
                                            checked={_isChecked}
                                            onChange={() => { }}
                                            style={{ position: 'static', margin: 0, height: 16, width: 16, flexShrink: 0, cursor: 'pointer' }}
                                        />
                                        <div style={{ width: 26, flexShrink: 0, color: '#888', textAlign: 'end' }}>
                                            {index + 1}.
                                        </div>
                                        <div style={{ flex: 1, minWidth: 110 }}>
                                            <div>{item?.stock?.name ?? '-'}</div>
                                            <small style={{ color: '#888' }}>
                                                {item?.cfMessage ?? '-'} | ເຫຼືອ: {item?.amount ?? 0} | {new Intl.NumberFormat('en-US').format(item?.stock?.price ?? 0)} {item?.stock?.currency ?? ''}
                                            </small>
                                        </div>
                                        {_isChecked && (
                                            //* ກົດໃສ່ຊ່ອງຈຳນວນຕ້ອງບໍ່ໄປຖອນຕິກແຖວ
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <NumberFormat
                                                    name="amount"
                                                    className="form-control"
                                                    style={{ width: 90 }}
                                                    onChange={(e) => {
                                                        const _max = item?.amount ?? 0;
                                                        const _value = parseInt((e.target.value ?? "").toString().replace(/,/g, "")) || 0;

                                                        //* ປ້ອນເກີນ — ປັບລົງໃຫ້ເທົ່າທີ່ເຫຼືອ ບໍ່ແມ່ນປະຕິເສດການພິມ
                                                        //* ຈະໄດ້ບໍ່ຕ້ອງລຶບພິມຄືນໃໝ່
                                                        if (_value > _max) {
                                                            updateRowAmount(item?.id, _max.toString());
                                                            addToast((item?.stock?.name ?? "") + " ເຫຼືອພຽງ " + new Intl.NumberFormat('en-US').format(_max), {
                                                                appearance: "warning",
                                                                autoDismiss: true,
                                                            });
                                                            return;
                                                        }

                                                        updateRowAmount(item?.id, e.target.value)
                                                    }}
                                                    value={_row?.amount ?? 1}
                                                    placeholder={"ສູງສຸດ " + new Intl.NumberFormat('en-US').format(item?.amount ?? 0)}
                                                    thousandSeparator={true}
                                                    prefix={""}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {selectedRows.length > 0 && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, fontWeight: 'bold' }}>
                                <span>ເລືອກແລ້ວ {selectedRows.length} ລາຍການ</span>
                                <span>
                                    ລວມ: {Object.keys(sumByCurrency()).map((currency) => new Intl.NumberFormat('en-US').format(sumByCurrency()[currency]) + " " + currency).join(" + ")}
                                </span>
                            </div>
                        )}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'end' }}>
                        <Button
                            onClick={() => {
                                if (createLoading || isSaving) return;
                                _clearData();
                                setShowCreateOrderModal(false);
                            }}
                            style={{ background: 'transparent', color: COLOR_APP_CANCEL, borderColor: COLOR_APP_CANCEL }}>
                            ຍົກເລີກ
                        </Button>
                        <Button
                            onClick={() => {
                                if (createLoading || isSaving) return;
                                _createOrder();
                            }}
                            style={{ background: COLOR_APP, marginLeft: 10, width: 100, border: 'none' }}>
                            {(createLoading || isSaving) ? <Spinner
                                size="sm"
                                animation="border"
                            /> : "ບັນທືກ"}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={notify.show} onHide={() => {
                if (isSendingBill) return;
                setNotify({ show: false, msg: "", color: "" })
            }}>
                <Modal.Body>
                    <h6 style={{ fontWeight: 'bold', alignSelf: 'center', color: notify.color }}>{notify.msg}</h6>

                    {/* ອໍເດີສ້າງສຳເລັດແລ້ວ ແຕ່ບິນສົ່ງບໍ່ອອກ — ໃຫ້ກົດສົ່ງຄືນໄດ້
                      * ກົດຊ້ຳໄດ້ບໍ່ຈຳກັດ ບໍ່ສ້າງອໍເດີເພີ່ມ ເພາະການສົ່ງບິນແຍກອອກມາແລ້ວ
                      */}
                    {billOrderId && (
                        <div style={{ display: 'flex', justifyContent: 'end', marginTop: 16 }}>
                            <Button
                                onClick={() => _resendBill()}
                                disabled={isSendingBill}
                                style={{ background: COLOR_APP, border: 'none', minWidth: 140 }}>
                                {isSendingBill ? <Spinner size="sm" animation="border" /> : "ສົ່ງບິນອີກຄັ້ງ"}
                            </Button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateOrderModal;